module.exports = __webpack_public_path__ + "img/empty-big.32807395.svg";